import React, { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import feedbackIcon from 'assets/img/image-feedback.png';
import { ModalContext } from 'App';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../actions';
import * as c from '../constant';
import ReviewTransactionFeedbackModal from './ReviewTransactionFeedbackModal';
import FeedbackQuestionsModal from './FeedbackQuestionsModal';
import FeedbackSuccessModal from '../components/FeedbackSuccessModal';

function WelcomeFeedbackModal({
  onClose,
  getFeedbackDataForFeedback,
  feedbackDataForFeedback,
  submitFeedback,
  allowAnonymousFeedback
}) {
  const setModal = useContext(ModalContext);
  const [infoStep, setInfoStep] = useState(1);

  useEffect(() => {
    getFeedbackDataForFeedback();
  }, [getFeedbackDataForFeedback]);

  const openReviewTransactionModal = useCallback(() => {
    let profile = {};
    try {
      profile = JSON.parse(localStorage.getItem('profile')) || {};
    } catch (e) {
      profile = {};
    }
    
    const closeModal = () => {
      if (onClose) return onClose();
      return setModal({ isOpen: false, content: null, title: '' });
    };

    const openQuestionsModal = (reviewFormData) => {
      const openSuccessModal = () => {
        setModal({
          isOpen: true,
          title: '',
          modalSize: 'modal-md',
          isCentered: true,
          hideHeader: true,
          content: <FeedbackSuccessModal onClose={closeModal} />,
        });
      };

      setModal({
        isOpen: true,
        title: '',
        modalSize: 'modal-md',
        isCentered: true,
        hideHeader: true,
        content: (
          <FeedbackQuestionsModal
            onClose={closeModal}
            initialFormData={reviewFormData}
            onBack={() => openReviewTransactionModal()}
            onSubmitted={(payload) => {
              submitFeedback(payload, () => {
                openSuccessModal();
              });
            }}
          />
        ),
      });
    };

    setModal({
      isOpen: true,
      title: '',
      modalSize: 'modal-md',
      isCentered: true,
      hideHeader: true,
      content: (
        <ReviewTransactionFeedbackModal
          profile={profile}
          feedbackDataForFeedback={feedbackDataForFeedback}
          onClose={closeModal}
          onProceed={openQuestionsModal}
          allowAnonymousFeedback={allowAnonymousFeedback}
        />
      ),
    });
  }, [feedbackDataForFeedback, onClose, setModal, allowAnonymousFeedback, submitFeedback]);

  return (
    <>
      <div className="modal-body">
        <div className="d-flex flex-column align-items-center text-center px-3 py-3">
          <div
            className="d-flex align-items-center justify-content-center mb-3"
            style={{
              width: 96,
              height: 96,
              borderRadius: '999px',
              background: '#F3F6FF',
            }}
          >
            <img src={feedbackIcon} alt="" width={56} height={56} />
          </div>

          <div className="font-weight-bold mb-3" style={{ fontSize: 28, lineHeight: 1.15 }}>
            CLIENT SATISFACTION SURVEY FORM
          </div>

          <div className="text-muted" style={{ maxWidth: 520, fontSize: 16, lineHeight: 1.6 }}>
            {infoStep === 1 ? (
              <>
                This Client Satisfaction Measurement (CSM) survey aims to track the client
                experience of government offices. Your answers will enable this office to provide
                a better service. For privacy and security, rest assured that all the information
                that you will share shall remain confidential.
                <br />
                <b>Anti-Red Tape Authority (ARTA)</b> - 8478-5099 / complaints@arta.gov.ph
                <br />
                <b>Presidential Action Center (PACe)</b> - 8888 / info@pacer.gov.ph
                <br />
                <b>CSE Contact Center ng Bayan</b> - 1-6565 / email@contactcenterngbayan.gov.ph
              </>
            ) : (
              <>
                The respondents are assured that the personal data and other sensitive data
                entrusted to the DICT shall be used with due diligence and prudence, for the sole
                purpose of gathering feedback. As such, upon accessing the DICT Client Feedback
                Mechanism form, you acknowledge and agree that the information may be used and
                disclosed by the DICT in accordance with any legal and regulatory standards and in
                compliance with the “Data Privacy Act of 2012”.
              </>
            )}
          </div>
        </div>
      </div>
      <div className="modal-footer gap-2">
        {infoStep === 1 ? (
          <button
            type="button"
            className="btn btn-dark btn-block"
            style={{ padding: '12px 16px', borderRadius: 8, fontWeight: 600 }}
            onClick={() => setInfoStep(2)}
          >
            Next
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-dark btn-block"
            style={{ padding: '12px 16px', borderRadius: 8, fontWeight: 600 }}
            onClick={openReviewTransactionModal}
          >
            Continue
          </button>
        )}
        <button
          type="button"
          className="btn btn-block btn-link text-dark"
          style={{ fontWeight: 600, textDecoration: 'none' }}
          onClick={onClose}
        >
          Skip
        </button>
      </div>
    </>
  );
}

WelcomeFeedbackModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  getFeedbackDataForFeedback: PropTypes.func.isRequired,
  feedbackDataForFeedback: PropTypes.instanceOf(Object),
  submitFeedback: PropTypes.instanceOf(Function).isRequired,
  allowAnonymousFeedback: PropTypes.number,
};

WelcomeFeedbackModal.defaultProps = {
  feedbackDataForFeedback: null,
  allowAnonymousFeedback: 0,
};

const mapStateToProps = ({ api }) => ({
  feedbackDataForFeedback:
    _.get(api, `${c.GET_FEEDBACK_DATA_FOR_FEEDBACK}.item`) || {},
});

const enhance = _.flowRight([connect(mapStateToProps, actions)]);

export default enhance(WelcomeFeedbackModal);
